import React from "react";

import {
  ProductTemplateEntryType,
  useGetProductTemplateConfig,
  useGetProductTemplateData,
} from "api/api-hooks/product-templates-hooks";
import { GanttProps } from "components/ComponentType";
import { Error } from "components/dashboard/product-template-table/ProductTemplateTable";
import { ProgressSpinner } from "primereact/progressspinner";
import { T } from "services/lang/LanguageService";
import GanttChart from "./GanttChart";

const GanttChartWrapper = (props: GanttProps) => {
  const params: ProductTemplateEntryType = {
    safeName: props.safeName,
    dateFrom: props.from,
    dateTo: props.to,
    filter: props.filter ?? props.defaultFilter,
  };

  const { data: templateData, isLoading } = useGetProductTemplateData(params, {
    enabled: Boolean(props.safeName || props.from || props.to),
  });
  const { data: configData } = useGetProductTemplateConfig(
    props.safeName,
    props.id ?? props.safeName
  );

  if (isLoading)
    return (
      <div className="demo-container p-p-4">
        <ProgressSpinner className="p-d-block p-mx-auto" />
      </div>
    );

  if (!templateData || templateData.length === 0)
    return (
      <div className="demo-container p-p-4">
        <Error text={T("error.no-data-found")} />
      </div>
    );

  return <GanttChart templateData={templateData} configData={configData} {...props} />;
};

export default GanttChartWrapper;
